<template>
  <el-popover placement="right" trigger="click" width="250" v-model="show">
    <div class="medication-info">
      <p>
        <strong>眼别：</strong>
        <el-select size="mini" v-model="model.CHPLeftRightEyes" placeholder="请选择眼别" style="width: 150px;"
          @change="handleChange($event, 'eye')">
          <el-option v-for="item in eye2SelectOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </p>
      <p><strong>处方：</strong>
        <el-select size="mini" v-model="model.CHPS_OP_ALL_Id" placeholder="请选择处方" style="width: 150px;"
          @change="handleChange($event, 'prescription')">
          <el-option v-for="item in prescriptionList" :key="item.S_OP_ID" :label="item.S_OP_IO_Type_Name"
            :value="item.S_OP_ID" />
        </el-select>
      </p>
    </div>
    <el-button slot="reference" type="text">{{ text || '关联处方' }}</el-button>
  </el-popover>
</template>
<script>
import { eye2SelectOptions, diameterSelectOptions, channelSelectOptions } from '../data/select-options';
import { getOkPrescriptionApi, updateCartProductApi } from '../api'
export default {
  name: 'OklensPrescriptionPopover',
  inject: ['chooseId'],
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      text: '',
      eye2SelectOptions,
      diameterSelectOptions,
      channelSelectOptions,
      show: false,
      prescriptionList: [],
    }
  },
  created() {
    this.getPrescriptionList();
  },
  methods: {
    // 获取处方列表
    async getPrescriptionList() {
      if (!this.chooseId) return;
      const { data } = await getOkPrescriptionApi(this.chooseId);
      if (data?.Result) {
        // 对象转化数组
        this.prescriptionList = Object.keys(data.Result).map(key => {
          return {
            S_OP_IO_Type_Name: key,
            S_OP_ID: data.Result[key],
          }
        }) || [];
      }
    },

    // 改变更新
    async handleChange(e, type) {
      try {
        // 眼别
        if (type === 'eye') {
          await updateCartProductApi(this.model);
        }
        // 处方
        if (type === 'prescription') {
          const { data } = await updateCartProductApi(this.model);
          if (data?.UpdateResult === 0) {
            const msg = `【${this.model.ProductRelation.ShopProduct.ProductName}】-${data?.msg}`
            this.$message.error(msg);
            this.model.CHPS_OP_ALL_Id = '';
          }
        }
        this.$emit('success', this.model);
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
<style scoped lang="scss">
.medication-info {
  p {
    margin: 10px 0;

    strong {
      width: 70px;
      display: inline-block;
    }
  }

  .btn-wrapper {
    display: flex;
    justify-content: flex-end;
  }
}
</style>